import React from 'react';

/**
 * FeatureBadge - Displays plan requirement badges (FREE, PRO)
 *
 * Usage:
 *   <FeatureBadge plan="free" />
 *   <FeatureBadge plan="pro" size="sm" />
 *   <FeatureBadge plan="pro" showIcon={true} />
 */
const FeatureBadge = ({ plan, size = 'md', showIcon = false, className = '' }) => {
  const planConfig = {
    free: {
      label: 'FREE',
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-300',
      icon: '🆓'
    },
    pro: {
      label: 'PRO',
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-700',
      borderColor: 'border-blue-300',
      icon: '⭐'
    }
  };

  const sizeClasses = {
    xs: 'text-xs px-1.5 py-0.5',
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  };

  const config = planConfig[plan?.toLowerCase()] || planConfig.free;
  const sizeClass = sizeClasses[size] || sizeClasses.md;

  return (
    <span
      className={`
        inline-flex items-center gap-1 rounded-md font-semibold
        border ${config.bgColor} ${config.textColor} ${config.borderColor}
        ${sizeClass} ${className}
      `}
      title={`${config.label} plan required`}
    >
      {showIcon && <span className="text-xs">{config.icon}</span>}
      {config.label}
    </span>
  );
};

export default FeatureBadge;
